import { create } from 'zustand';

export interface ProductInfo {
  id: string;
  name: string;
  description: string;
  features: string[];
  applications: string[];
  specifications?: Record<string, string>;
}

export interface SectorInfo {
  id: string;
  name: string;
  description: string;
  applications: string[];
  benefits: string[];
}

export interface KnowledgeBase {
  products: ProductInfo[];
  sectors: SectorInfo[];
  generalInfo: {
    companyDescription: string;
    usp: string[];
    values: string[];
  };
}

// Export the database directly for non-React usage
export const database: KnowledgeBase = {
  products: [
    {
      id: 'brandvision-kiosk',
      name: 'Brandvision Kiosk',
      description: 'Een krachtige kiosk voor organisaties die hun visuele identiteit willen communiceren, perfect voor winkelomgevingen, hotellobby\'s en corporate entrees.',
      features: [
        'Gepoedercoat stalen frame',
        'Verschillende schermformaten',
        'Verwisselbare textieldoeken',
        'Dynamische content weergave'
      ],
      applications: [
        'Winkelomgevingen',
        'Hotellobby\'s',
        'Corporate entrees',
        'Productlanceringen'
      ]
    },
    {
      id: 'clearvision-kiosk',
      name: 'Clearvision Kiosk',
      description: 'Een slanke, transparante kiosk die perfect is voor etalages en showrooms, met behoud van optimaal zicht op producten.',
      features: [
        'Transparant design',
        'Enkel- of dubbelzijdige uitvoering',
        'Minimalistisch ontwerp',
        'Subtiele integratie'
      ],
      applications: [
        'Etalages',
        'Showrooms',
        'Winkelstraten',
        'Productpresentaties'
      ]
    },
    {
      id: 'touch-screen-table',
      name: 'Touch Screen Table',
      description: 'Interactieve tafel voor zelfstandige navigatie door content, ideaal voor musea en showrooms.',
      features: [
        'Touchscreen functionaliteit',
        'Ergonomische hoek',
        'Interactieve navigatie',
        'Modulaire basis'
      ],
      applications: [
        'Musea',
        'Showrooms',
        'Hotels',
        'Informatiecentra'
      ]
    },
    {
      id: 'ceiling-kiosk',
      name: 'Ceiling Kiosk',
      description: 'Een innovatieve plafondgemonteerde kiosk, ideaal voor ruimtes waar vloeroppervlak beperkt is.',
      features: [
        'Plafondmontage',
        'Verstelbare hoogte',
        'Enkel- of dubbelzijdig',
        'Ruimtebesparend design'
      ],
      applications: [
        'Luchthavens',
        'Stations',
        'Winkelcentra',
        'Conferentiezalen'
      ]
    },
    {
      id: 'wall-kiosk',
      name: 'Wall Kiosk',
      description: 'Een strakke, wandgemonteerde kiosk die naadloos integreert in elk interieur.',
      features: [
        'Wandmontage',
        'Strak design',
        'Geïntegreerde kabels',
        'Professionele uitstraling'
      ],
      applications: [
        'Corporate lobby\'s',
        'Wachtruimtes',
        'Musea',
        'Hotels'
      ]
    }
  ],
  sectors: [
    {
      id: 'retail',
      name: 'Retail & Winkelcentra',
      description: 'Dynamische klantbeleving met focus op inspiratie en productinformatie.',
      applications: [
        'Productpresentaties',
        'Seizoensgebonden acties',
        'Collectie-uitlichting',
        'Interactieve productinformatie'
      ],
      benefits: [
        'Verhoogde klantbetrokkenheid',
        'Real-time content aanpassing',
        'Verbeterde merkbeleving',
        'Efficiënte informatievoorziening'
      ]
    },
    {
      id: 'corporate',
      name: 'Corporate Omgevingen',
      description: 'Professionele communicatieoplossingen voor kantoren en bedrijfsruimtes.',
      applications: [
        'Interne communicatie',
        'Bezoekersregistratie',
        'Bedrijfspresentaties',
        'Wayfinding'
      ],
      benefits: [
        'Professionele uitstraling',
        'Efficiënte informatiedeling',
        'Verbeterde bezoekerservaring',
        'Consistente merkbeleving'
      ]
    }
  ],
  generalInfo: {
    companyDescription: 'Eye Catching Media is een Nederlands bedrijf gespecialiseerd in modulaire kioskoplossingen. We combineren hoogwaardige hardware met innovatieve software voor impactvolle merkpresentaties.',
    usp: [
      'Nederlandse productie voor maximale kwaliteitscontrole',
      'Snelle levering door voorraadgestuurd systeem',
      'Wereldwijde verzending mogelijk',
      'Modulair systeem voor maximale flexibiliteit',
      'Duurzame materialen en constructie'
    ],
    values: [
      'Kwaliteit',
      'Innovatie',
      'Duurzaamheid',
      'Flexibiliteit',
      'Klanttevredenheid'
    ]
  }
};

// Keep the Zustand store for React components
export const useDatabase = create(() => database);